import { ParseObject } from './parse-object';

export class Role extends ParseObject {
  public static readonly CLASS_NAME = '_Role';
  public static readonly NAME_KEY = 'name';
  public static readonly USERS_KEY = 'users';
  public static readonly DISPLAYED_NAME_KEY = 'displayedName';

  public static readonly ADMIN_ROLE = 'Admin';
  public static readonly USER_ROLE = 'User';

  constructor() {
    super(Role.CLASS_NAME);
  }

  public get name(): string {
    return this.get(Role.NAME_KEY);
  }

  public set name(name: string) {
    this.set(Role.NAME_KEY, name);
  }

  public get displayedName(): string {
    return this.get(Role.DISPLAYED_NAME_KEY);
  }

  public set displayedName(displayedName: string) {
    this.set(Role.DISPLAYED_NAME_KEY, displayedName);
  }

  public get users() {
    return this.relation(Role.USERS_KEY);
  }
}

Parse.Object.registerSubclass(Role.CLASS_NAME, Role);



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/data/role.ts